angular.module('pitch.app')
.directive('socialIcons', function(SiteContext) {
    "use strict";
    return {
        restrict: 'A',
        replace: true,
        link: function($scope, elem, attr, ctrl) {
            $scope.mappings = {
                spotify: {
                    icon: 'fa-spotify',
                    name: 'Spotify'
                },
                twitter: {
                    icon: 'fa-twitter',
                    name: 'Twitter'
                },
                facebook: {
                    icon: 'fa-facebook-official',
                    name: 'Facebook'
                },
                instagram: {
                    icon: 'fa-instagram',
                    name: 'Instagram'
                },
                youtube: {
                    icon: 'fa-youtube',
                    name: 'Youtube'
                }
            };

            SiteContext.get().then(function(r) {
                $scope.data = r.social_link;
                //@todo remove
               //  $scope.data = {
               //    "facebook":"http://facebook.com",
               //    "twitter":"http://twitter.com",
               //    "instagram":"http://instagram.com",
               //    "youtube":"http://youtube.com",
               //    "spotify":"http://spotify.com"
               // };
            });
        },
        template:   '<ul class="social-icons list-unstyled list-inline">' +
                        '<li ng-repeat="(key, value) in ::data">' +
                            '<a target="blank" tabindex="-1" ng-href="[[::value]]" class="btn-animate">' +
                                '<i class="fa [[::mappings[key].icon]]"></i>' +
                                '<span class="sr-only">SonyATV on [[::mappings[key].name]]</span>' +
                            '</a>' +
                        '</li>' +
                    '</ul>'
    };
})
;




// WEBPACK FOOTER //
// ./src/AppBundle/Resources/js/angular/directives/socialIcons.js